<template>
  <!-- 导出设置：水印文字 + 位置模式（平铺/指定角落/顶部横条），下方实时预览效果；不做缓存，每次导出重新设置 -->
  <el-dialog title="导出设置" :visible.sync="innerVisible" width="560px" :close-on-click-modal="false" @open="initForm">
    <el-form label-width="90px" size="small">
      <el-form-item label="水印文字">
        <el-input v-model="form.text" maxlength="50" show-word-limit placeholder="留空 = 不加水印" />
      </el-form-item>
      <el-form-item v-if="form.text" label="水印颜色">
        <el-color-picker v-model="form.color" size="small" :predefine="predefineColors" />
        <span class="wm-tip" style="margin-left: 8px">默认白色</span>
      </el-form-item>
      <template v-if="form.text">
        <el-form-item label="位置模式">
          <el-radio-group v-model="form.mode">
            <el-radio-button label="tile">全屏平铺</el-radio-button>
            <el-radio-button label="corner">指定角落</el-radio-button>
            <el-radio-button label="top">顶部横条</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="form.mode === 'corner'" label="角落">
          <el-checkbox-group v-model="form.corners">
            <el-checkbox label="tl">左上</el-checkbox>
            <el-checkbox label="tr">右上</el-checkbox>
            <el-checkbox label="bl">左下</el-checkbox>
            <el-checkbox label="br">右下</el-checkbox>
          </el-checkbox-group>
          <div class="wm-tip">可只勾一个角（如仅右下角）</div>
        </el-form-item>
        <el-form-item v-if="form.mode === 'tile'" label="密度">
          <el-radio-group v-model="form.density">
            <el-radio-button label="sparse">疏</el-radio-button>
            <el-radio-button label="medium">中</el-radio-button>
            <el-radio-button label="dense">密</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </template>
    </el-form>

    <!-- 效果预览：模拟一页深色幻灯片，水印层与导出 HTML 同一渲染函数实时生成 -->
    <div v-if="form.text" class="wm-preview">
      <div class="wm-preview-slide">
        <div class="wm-fake-title"></div>
        <div class="wm-fake-line"></div>
        <div class="wm-fake-line wm-fake-short"></div>
        <div class="wm-fake-img"></div>
        <div class="wm-preview-wm" v-html="previewWm"></div>
      </div>
      <div class="wm-tip">↑ 预览效果（文字/模式/角落/密度改动即时刷新）</div>
    </div>

    <div slot="footer">
      <el-button size="small" @click="innerVisible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="onConfirm">导 出</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { buildWatermarkHtml } from '@/utils/pptRender'

export default {
  name: 'ExportWmDialog',
  props: {
    value: { type: Boolean, default: false },
    // 该导出类型的默认水印文字（验证版传入「验证专用·禁止上传」，受保护版传空串）
    presetText: { type: String, default: '' }
  },
  data() {
    return {
      // 预置色块：白色默认色饱和度为 0，直接拖色相条无效果（HSV 特性），
      // 先点一个有彩色的预置色再拖色相条即可正常选色
      predefineColors: ['#f56c6c', '#e6a23c', '#67c23a', '#409eff', '#909399', '#ffffff'],
      form: { text: '', mode: 'tile', corners: ['tl', 'tr', 'bl', 'br'], density: 'medium', color: '#ffffff' }
    }
  },
  computed: {
    innerVisible: {
      get() { return this.value },
      set(v) { this.$emit('input', v) }
    },
    // 与导出产物同一个 buildWatermarkHtml 实时渲染，所见即所得
    previewWm() {
      return buildWatermarkHtml(this.form)
    }
  },
  methods: {
    // 每次打开都重置为类型默认值，不缓存上次设置（避免误用不合适的水印）
    initForm() {
      this.form = { text: this.presetText, mode: 'tile', corners: ['tl', 'tr', 'bl', 'br'], density: 'medium', color: '#ffffff' }
    },
    onConfirm() {
      if (this.form.mode === 'corner' && (!this.form.corners || !this.form.corners.length)) {
        this.$message.warning('请至少勾选一个角')
        return
      }
      this.$emit('confirm', {
        text: this.form.text,
        mode: this.form.mode,
        corners: (this.form.corners || []).slice(),
        density: this.form.density,
        color: this.form.color
      })
      this.innerVisible = false
    }
  }
}
</script>

<style scoped>
.wm-tip {
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
}
/* 预览：16:9 模拟幻灯片，深色背景让白色水印可见（与导出页 #wm 同规则） */
.wm-preview {
  margin-top: 4px;
}
.wm-preview-slide {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  background: linear-gradient(135deg, #33507e 0%, #22344f 100%);
  border-radius: 6px;
  overflow: hidden;
}
.wm-preview-wm {
  position: absolute;
  inset: 0;
  pointer-events: none;
  overflow: hidden;
  color: #fff;
  z-index: 30;
}
.wm-fake-title {
  position: absolute;
  left: 6%;
  top: 10%;
  width: 40%;
  height: 10%;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.85);
}
.wm-fake-line {
  position: absolute;
  left: 6%;
  top: 32%;
  width: 52%;
  height: 6%;
  border-radius: 3px;
  background: rgba(255, 255, 255, 0.55);
}
.wm-fake-line.wm-fake-short {
  top: 44%;
  width: 38%;
}
.wm-fake-img {
  position: absolute;
  right: 6%;
  bottom: 12%;
  width: 30%;
  height: 44%;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.28);
}
</style>
